import Image from 'next/image';

export const LogoLogin = () => {
  return (
    <Image
      src="/nabis-logo-sign.svg"
      width="36"
      height="36"
      alt="logo-sign"
      priority
      style={{ marginBottom: '54px', marginTop: '-90px', marginLeft: '-18px' }}
    />
  );
};
